module.exports = __webpack_public_path__ + "img/ctf-talabat.75edc142.png";